import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { AnimatePresence } from "framer-motion"
import Measure from 'react-measure'

import { ListTile, PopOut, Animation, Button, Icon } from 'components'
import { PageInput, DeleteDialogue, IconInput } from 'features'
import { pageContext } from 'context'
import ContextMenu from '../ContextMenu'
import {FaEdit, FaArchive, FaTrashAlt, FaAngleLeft} from 'react-icons/fa'

import * as actionCreators from 'store/actions'

const Line = styled.hr`
    border-color: var(--secondary-accent-color);
`;

const Title = styled.div`
    grid-template-columns: 2rem auto 2rem;
    display: grid;
    justify-items: center;
    align-items: center;
    margin-bottom: 0.3rem;
    font-weight: bolder;
    font-size: 0.9rem;
`

class PageOptions extends Component {
    constructor(props) {
        super(props);
        this.page = this.props.page
        this.state = {
            content: null,
            boundingRect: null
        }
        this.exitButtonStyle = {
            backgroundColor:'var(--secondary-color)',
            margin:'0 0rem 0 0',
            padding: '0.5rem',
            boxShadowColor: 'transparent'
        }
    }

    _getNextPage = () => {
        let nextPageID = null
        const pageIDs = Object.values(this.props.data['page_order'])
        pageIDs.map(pageID => {
            const pageStatus = this.props.data['pages'][pageID]['page_details']['status'];
            if (pageStatus === pageContext.STATUS.ACTIVE && pageID !== this.page.pageID) {
                nextPageID = pageID;
            }
        })
        return nextPageID;
    }

    _selectNextPage = () => {
        if(this.props.activePageID === this.page.pageID){
            const nextPageID = this._getNextPage()
            if(!nextPageID){
                this.changePageHandler('INBOX','Modules')
            } else {
                this.changePageHandler(nextPageID,'Pages')
            }  
        }
    }

    changePageHandler(pageID, type) {
        let user = this.props.user
        user['activePageID'] = pageID
        user['activePageType'] = type
        this.props.updateUser(user)
    }

    deletePageHandler = () => {
        // Select new page if needed
        // this._selectNextPage()

        // Delete page
        // this.props.deletePage(this.props.uid, this.page.pageID, this.props.data)
        this.props.deletePage(this.page.pageID, this.props.data, this.props.user)

        // Close options
        this.props.closeHandler()
    }

    archivePageHandler = () => {
        // // Select new page if needed
        // this._selectNextPage()

        // // Archive page
        // let updatedPage = {...this.page}
        // updatedPage['status'] = updatedPage['status'] === pageContext.STATUS.ACTIVE ? pageContext.STATUS.ARCHIVE : pageContext.STATUS.ACTIVE
        // this.props.updatePage(updatedPage, this.props.data)

        // // Close options
        // this.props.closeHandler()


        // Archive page
        let updatedPage = {...this.page}
        updatedPage['status'] = updatedPage['status'] === pageContext.STATUS.ACTIVE ? pageContext.STATUS.ARCHIVE : pageContext.STATUS.ACTIVE
        // console.log(updatedPage)
        this.props.updatePageStatus(updatedPage, this.props.data, this.props.user, this.props.sessionId)

        // Close options
        this.props.closeHandler()
    }
    
    render(){
        let content = null
        // console.log('[PageOptions]', this.page)

        switch (this.state.content){
            case 'edit':
                content = 
                <AnimatePresence key='edit'>
                    <div key='edit'></div>
                    <Animation key='edit' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                            <PageInput page={this.props.page} inline closeHandler2={this.props.closeHandler}/>
                        </div>
                    </Animation>
                </AnimatePresence>
                break

            case 'delete':
                content = 
                <AnimatePresence key='delete'>
                    <div key='placeholder'></div>
                    <Animation key='delete' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <DeleteDialogue subtitle='(Action cannot be undone)'
                            onDelete={this.deletePageHandler}
                            closeHandler={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'archive':
                content = 
                <AnimatePresence key='archive'>
                    <div key='placeholder'></div>
                    <Animation key='archive' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <DeleteDialogue submitText={this.props.page['status'] === pageContext.STATUS.ACTIVE ? 'Archive' : 'Unarchive'}
                            onDelete={this.archivePageHandler}
                            closeHandler={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'main':
                content =
                <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile onSelect={() => this.setState({content: 'edit'})} text='Edit' icon={<FaEdit/>}/>
                        <ListTile onSelect={() => this.setState({content: 'archive'})} text={this.page.status === pageContext.STATUS.ACTIVE  ? 'Archive' : 'Unarchive'} icon={<FaArchive/>}/>
                        <ListTile onSelect={() => this.setState({content: 'delete'})} text='Delete' icon={<FaTrashAlt/>}/>
                    </Animation>
                </AnimatePresence>
                break

            default:
                content =
                <AnimatePresence key='default'>
                    <Animation key='default' boundingRect={this.state.boundingRect}>
                        <ListTile onSelect={() => this.setState({content: 'edit'})} text='Edit' icon={<FaEdit/>}/>
                        <ListTile onSelect={() => this.setState({content: 'archive'})} text={this.page.status === pageContext.STATUS.ACTIVE  ? 'Archive' : 'Unarchive'} icon={<FaArchive/>}/>
                        <ListTile onSelect={() => this.setState({content: 'delete'})} text='Delete' icon={<FaTrashAlt/>}/>
                    </Animation>
                </AnimatePresence>
        }
        return (
            <ContextMenu>
                <Measure
                    bounds
                    onResize={contentRect => {
                        this.setState({ boundingRect: contentRect.bounds })
                    }}
                >
                    {({ measureRef }) => (
                        <div ref={measureRef}>{content}</div>
                    )}
                </Measure>
            </ContextMenu>
        )
    }    
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        // data: state.db.data,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updatePage: (page, data, sessionId) => dispatch(actionCreators.updatePage(page, data, sessionId)),
        updatePageStatus: (page, data, user, sessionId) => dispatch(actionCreators.updatePageStatus(page, data, user, sessionId)),
        deletePage: (pageID, data, user) => dispatch(actionCreators.deletePage(pageID, data, user)),
        updateUser: (user) => dispatch(actionCreators.updateUser(user))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PageOptions);